(() => {
  const rootSelector = '[data-cc-per-pouch-root]';

  const getCurrencyFormatter = (currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch (_error) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  };

  const initialize = (root) => {
    if (root.dataset.ccPerPouchReady === 'true') return;

    const output = root.querySelector('[data-cc-per-pouch-price]');
    const dataNode = root.querySelector('[data-cc-per-pouch-data]');
    if (!output || !dataNode) return;

    let pricing;
    try {
      pricing = JSON.parse(dataNode.textContent);
    } catch (_error) {
      return;
    }

    root.dataset.ccPerPouchReady = 'true';
    const formatter = getCurrencyFormatter(pricing.currency || 'USD');
    const pouchCount = Number(pricing.pouchCount) || 1;
    const productForm = document.getElementById(root.dataset.ccProductFormId);
    const planIds = new Set(
      Object.values(pricing.variants || {}).flatMap((variant) => Object.keys(variant.plans || {})),
    );

    const getVariantId = () => {
      const variantControl = productForm?.querySelector('[name="id"]');
      return String(variantControl?.value || root.dataset.ccInitialVariantId || '');
    };

    const getSellingPlanId = () => {
      const namedControls = [
        ...(productForm?.querySelectorAll('[name="selling_plan"]') || []),
        ...root.querySelectorAll('[name="selling_plan"]'),
      ].filter((control, index, controls) => controls.indexOf(control) === index && !control.disabled);

      if (namedControls.length) {
        const selected = namedControls.find((control) => {
          const type = (control.type || '').toLowerCase();
          const isActive = !['radio', 'checkbox'].includes(type) || control.checked;
          return isActive && planIds.has(String(control.value || ''));
        });
        return selected ? String(selected.value) : '';
      }

      const selectedPlanControl = [...root.querySelectorAll('input:checked, option:checked, [aria-checked="true"]')]
        .find((control) => {
          const candidate = control.dataset.sellingPlanId || control.value;
          return !control.disabled && planIds.has(String(candidate || ''));
        });

      return String(selectedPlanControl?.dataset.sellingPlanId || selectedPlanControl?.value || '');
    };

    const update = () => {
      const currentOutput = root.querySelector('[data-cc-per-pouch-price]');
      if (!currentOutput) return;
      const variant = pricing.variants?.[getVariantId()];
      if (!variant) return;

      const sellingPlanId = getSellingPlanId();
      const totalPrice = sellingPlanId && variant.plans?.[sellingPlanId] != null
        ? Number(variant.plans[sellingPlanId])
        : Number(variant.price);

      if (!Number.isFinite(totalPrice)) return;
      const nextText = `${formatter.format(totalPrice / pouchCount / 100)} per pouch`;
      if (currentOutput.textContent.trim() !== nextText) currentOutput.textContent = nextText;
    };

    const scheduleUpdate = () => {
      update();
      window.setTimeout(update, 60);
      window.setTimeout(update, 250);
      window.setTimeout(update, 700);
    };

    root.addEventListener('change', scheduleUpdate, true);
    root.addEventListener('click', scheduleUpdate, true);

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'aria-checked', 'class'],
    });

    scheduleUpdate();
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.(rootSelector)) initialize(scope);
    scope.querySelectorAll?.(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
